<template>
  <view class="w100 n-container flex " >
   <view class="navbar">
     <el-menu
    :default-active="activeIndex"
    class="el-menu-demo"
    mode="horizontal"
    :ellipsis="isXsScreen || isMenuVisible"
    :popper-offset="20"
    background-color="transparent"
    @select="handleSelect"
    :router="true"
  >
    <el-menu-item index="0">
        <img class="logo" src="../assets/imgs/logo.png"/>
    </el-menu-item>
    <el-menu-item index="/" >首页</el-menu-item>
    <el-menu-item index="/product">产品中心</el-menu-item>
    <el-menu-item index="/about" >关于我们</el-menu-item>
    <el-menu-item index="/join" >加入我们</el-menu-item>
  </el-menu>
   </view>
  </view>
</template>


<script>

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
    return{
        activeIndex:" ",
        isMenuVisible: false,
    }
  },
  computed: {
    isXsScreen() {
      // 根据窗口大小判断是否为 xs 屏幕，这里仅为示例，实际应根据 Element Plus 的 Breakpoint 来判断。
      return window.innerWidth <= 768; // 或者使用 Element Plus 的 Breakpoint 服务来判断。
    }
  },
  methods:{
    handleSelect(key, keyPath){
        console.log(this.activeIndex)
        console.log(key, keyPath)
        
    },
     toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible; // 切换菜单的显示状态
    }
  },
  mounted(){
    this.activeIndex = this.$route.fullPath
  }
}
</script>


<style scoped>
.n-container{
  background-color: #ffffffb0 !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
}
.navbar{
    width: 90%;
    margin: 0 auto;
}

.logo{
  width: 10rem;
  height: 2rem;
}
.el-menu{
    width: 100%;
}
.el-menu--horizontal > .el-menu-item:nth-child(1) {
  margin-right: auto;
}




</style>